import type { AdminBondRequest } from "@portal/api/bond-request/admin/types";
import { Followers } from "@portal/components/ui/Followers";
import { getStatusCardByStatus } from "@portal/components/ui/StatusCard";
import { TruncatedLabel } from "@portal/components/ui/TruncatedLabel";
import type { FC } from "react";
import { formatDisplayTitle } from "../../../../utils";
import type { FollowersControl } from "./types";

export type AdminBondRequestStickyPanelProps = {
	request: AdminBondRequest;
	followers: FollowersControl["followers"];
};

export const AdminBondRequestStickyPanel: FC<AdminBondRequestStickyPanelProps> = ({
	request,
	followers,
}) => {
	return (
		<div
			data-testid="admin-bond-request-sticky-panel"
			className="flex items-center gap-3 whitespace-nowrap"
		>
			<TruncatedLabel
				label={`${formatDisplayTitle(request.displayTitle)} · ${request.principal.name}`}
				className="hidden max-w-[240px] text-[12px] font-[550] text-secondary lg:block"
			/>
			{getStatusCardByStatus(request.status, "", { iconOnly: true })}
			<span className="hidden xl:block">
				<Followers followers={followers} />
			</span>
		</div>
	);
};
